module.exports = __webpack_public_path__ + "media/images/newsletter/setouchi/map-setouchi-6d4c4f092f5915a4d8ba88208d4c204e.png";